import React from 'react';
import styled from 'styled-components';

import ICONS from 'components/Icons';

const CardPaymentImage = styled.img`
  width: 8.1em;
  margin-top: 6px;
`;

export const CardPayment = () => (
  <CardPaymentImage
    src={ICONS.ERROR.PAYMENT.CARD}
    tabIndex={-1}
    alt="Card payment graphic"
  />
);

export default CardPayment;
